import { render, staticRenderFns } from "./IconCalendarBig.vue?vue&type=template&id=7b8f91e8&"
import script from "./IconCalendarBig.vue?vue&type=script&lang=js&"
export * from "./IconCalendarBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b8f91e8')) {
      api.createRecord('7b8f91e8', component.options)
    } else {
      api.reload('7b8f91e8', component.options)
    }
    module.hot.accept("./IconCalendarBig.vue?vue&type=template&id=7b8f91e8&", function () {
      api.rerender('7b8f91e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCalendarBig.vue"
export default component.exports